import { Text } from '@fluentui/react-components';
import CheckoutBox from 'components/core/CheckoutBox/CheckoutBox';
import { useCart } from 'contexts/CartContext/CartContext.hooks';
import { useNextStepsStyles } from './NextSteps.styles';
import { useEffect } from 'react';
import MainButton from 'components/core/MainButton/MainButton';
import { HubspotWindow } from 'types/HubSpot';

declare let window: HubspotWindow;

const InternetOrderNextSteps = () => {
    const styles = useNextStepsStyles();

    const { confirmInternetOrder } = useCart();

    useEffect(() => {
        confirmInternetOrder();
    }, []);

    const handleChatWithUs = () => {
        if (window.HubSpotConversations) {
            window.HubSpotConversations.widget.open();
        }
    };

    return (
        <div>
            <CheckoutBox>
                <div className={styles.shippingSection}>
                    <Text size={400} weight='semibold'>
                        Thank You for Your Order!
                    </Text>
                    <Text>Your request has been received!</Text>
                    <Text>
                        There&apos;s just <span style={{ fontWeight: 'bold' }}>one more step</span>{' '}
                        before we can complete your order.
                    </Text>

                    <Text size={400} weight='semibold'>
                        Coverage Validation in Progress
                    </Text>
                    <Text>
                        We&apos;re currently verifying service availability for your location. One
                        of our representatives will reach out to you soon to confirm your coverage
                        and finalize the details of your installation.
                    </Text>

                    <Text size={400} weight='semibold'>
                        What&apos;s Next?
                    </Text>
                    <ul style={{ margin: '0' }}>
                        <li>Our team will contact you by phone to complete your order.</li>
                        <li>
                            Once confirmed, we&apos;ll schedule your{' '}
                            <span style={{ fontWeight: 'bold' }}>installation and activation</span>.
                        </li>
                    </ul>
                </div>
            </CheckoutBox>

            <CheckoutBox className={styles.questionsSection}>
                <div className={styles.shippingSection}>
                    <Text size={400} weight='semibold'>
                        Have questions?
                    </Text>
                    <Text>
                        Chat with us on-line or call us at{' '}
                        <a href='tel:1-877-842-3765'>1-877-842-3765</a>.
                    </Text>
                    <div className={styles.questionButtons}>
                        <MainButton type='primary' text='Chat with us' onClick={handleChatWithUs} />
                    </div>
                    <Text>
                        Thank you for choosing Viaero Wireless, we&apos;re excited to get you
                        connected!
                    </Text>
                </div>
            </CheckoutBox>
        </div>
    );
};

export default InternetOrderNextSteps;
